import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { CommonService } from '../../../services/common.service';
import {QualityService} from '../quality.service';
import { environment } from '../../../../environments/environment';
import { ViewmodalComponent } from '../viewmodal/viewmodal.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: "app-qualityassurancepending",
    templateUrl: "./qualityassurancepending.component.html",
    styleUrls: ["./qualityassurancepending.component.sass"],
})
export class QualityassurancependingComponent implements OnInit {
    loader = true;
    items: any;
    pdfdata: any;
    pdfviewer: any;
    deleteid;
    any;
    arr_temp_all: [];
    arr_temp: any;
    listData: any;
    p = 1;
    nodata = false;
    searchText = "";
    query: any = {
        page: 1,
        limit: environment.defaultPageSize,
        userType: 1,
    };
    totalRecords = 0;
    recordsPerPage: number;
      APIENDPOINTFORCSV = ""


    constructor(
        private quality: QualityService,
        private modalService: BsModalService,
        private commonService: CommonService
    ) {
        this.recordsPerPage = environment.defaultPageSize;
                    this.APIENDPOINTFORCSV = environment.APIEndpoint;

    }

    private searchTerms = new Subject<string>();

    ngOnInit() {
        this.getqualitylist("pending");
        this.arr_temp = [];
        this.searchTerms
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((value) => {
                this.query.search = value;
                this.pageChanged({ page: 1 });
                // this.engineerlist();
            });
    }

    getValue(event: Event): void {
        const inputElement = event.target as HTMLInputElement;
        this.searchTerms.next(inputElement.value);
        // return (event.target as HTMLInputElement).value;
    }
    
    getqualitylist(obj) {
        this.query.search = this.searchText;
        this.quality.getqualityListV2(obj, this.query).subscribe(
            (result: any) => {
                const items = result.data.data;
                this.items = items;
                this.totalRecords = result.data.totalCount;
                this.arr_temp_all = this.items.map((result) => result._id);
                this.loader = false;
                this.nodata = false;
            },
            (error: any) => {
                this.loader = false;
                this.nodata = true;
            }
        );
    }

    pageChanged(event: any): void {
        this.p = event.page;
        this.query.page = this.p;
        this.getqualitylist("pending");
    }

    Deletefnc() {
        // this.obj = {
        //obj : this.arr_temp
        //}
        if (this.arr_temp.length == 0) {
            this.commonService.toast(
                "Please select an enquiry to delete",
                "Error"
            );
        } else {
            this.quality.deleteDatamultiple(this.arr_temp).subscribe(
                (result: any) => {
                    this.loader = true;
                    this.getqualitylist("pending");
                    this.loader = false;
                    this.commonService.toast("Deletion successful", "Success");
                },
                (error: any) => {
                    this.loader = false;
                    //this.nodata = true;
                    // this.commonService.toast(error.error.message, 'Error');
                }
            );
        }
    }
    deleteselection(_id, check) {
        if (check.target.checked == true) {
            this.arr_temp.push(_id);
            //console.log(this.arr_temp);
        } else if (check.target.checked == false) {
            for (let j = 0; j < this.arr_temp.length; j++) {
                if (this.arr_temp[j] === _id) {
                    this.arr_temp.splice(j, 1);
                }
            }
            // console.log(this.arr_temp);
        }
    }
    deleteall(event) {
        const checked = event.target.checked;
        this.items.forEach((item) => (item.selected = checked));
        if (checked == true) {
            this.arr_temp = this.arr_temp_all;
        } else if (checked == false) this.arr_temp = [];
        // console.log(this.arr_temp);
    }
    changeStatus(_id, event) {
        const status = event.target.value;
        this.quality.updateData(_id, { status: status }).subscribe(
            (result: any) => {
                this.commonService.toast(
                    `Booking status updated successfully.`,
                    "Success"
                );
                this.getqualitylist("pending");
            },
            (error) => {
                this.commonService.toast(error.error.message, "Error");
            }
        );
    }
    deltedata() {
        const Id = this.deleteid;
        this.quality.deleteData(Id).subscribe(
            (result: any) => {
                this.loader = false;
                if (result.success === true) {
                    this.commonService.toast(result.message, "Success");
                } else {
                    this.commonService.toast(result.message, "Error");
                }
                this.getqualitylist("pending");
            },
            (error: any) => {
                this.loader = false;
                this.commonService.toast(error.error.message, "Error");
            }
        );
    }

    saveid(Id) {
        this.deleteid = Id;
    }

    userModal(userid) {
        //console.log(userid);
        const initialState = {
            userid: userid,
        };
        this.modalService.show(ViewmodalComponent, {
            initialState,
            class: "modal-lg",
        });
        this.modalService.onHide.subscribe(() => {});
    }
         exportAsXLSX(): void {

        const status = encodeURIComponent("pending"); // encodes the space
        const url = this.APIENDPOINTFORCSV + '/'+ 'quality/generate-csv-for-quality-report/' + status;

         
         const newTab = window.open(url, '_blank');
    
            console.log("url:",url)
            if (newTab) {
            newTab.onload = () => {
        
                newTab.location.href = url;  // This triggers the download if the server is set up correctly
            };
            } else {
            console.error('Could not open new tab');
            }
      }
}
  